import { Link } from 'react-router-dom'

const brandFont = {
  fontFamily: '"Helvetica Neue", "HelveticaNeue-UltraLight", -apple-system, sans-serif',
  fontWeight: 100,
} as const

const bodyFont = {
  fontFamily: '"Helvetica Neue", sans-serif',
  fontWeight: 300,
} as const

const COLUMNS = [
  {
    title: 'Developers',
    links: [
      { label: 'API Reference', href: '/api' },
      { label: 'Playground', href: '/playground' },
      { label: 'Status', href: '/status' },
      { label: 'Full Docs', href: 'https://lukhas.dev', external: true },
    ],
  },
  {
    title: 'APIs',
    links: [
      { label: 'MATRIZ Reasoning', href: '/api' },
      { label: 'Guardian Ethics', href: '/api' },
      { label: 'Identity (ΛiD)', href: '/api' },
      { label: 'Memory Folds', href: '/api' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { label: 'Privacy Policy', href: '/privacy' },
      { label: 'Terms of Service', href: '/terms' },
      { label: 'Cookie Policy', href: '/cookies' },
    ],
  },
]

export default function SiteFooter() {
  return (
    <footer className="border-t border-white/[0.07] bg-black/20 backdrop-blur-sm">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {/* Brand column */}
          <div>
            <span className="text-lg text-white/80 tracking-[0.3em] block mb-4" style={brandFont}>
              LUKH&Lambda;S<span className="text-vision-teal">.IO</span>
            </span>
            <p className="text-sm text-white/40 leading-relaxed" style={bodyFont}>
              Developer portal for the LUKHAS Constellation framework.
            </p>
          </div>

          {COLUMNS.map((col) => (
            <div key={col.title}>
              <h3
                className="text-xs text-white/50 tracking-[0.15em] uppercase mb-4"
                style={bodyFont}
              >
                {col.title}
              </h3>
              <ul className="space-y-2">
                {col.links.map((link) =>
                  'external' in link && link.external ? (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-sm text-white/40 hover:text-white/70 transition-colors"
                        style={bodyFont}
                      >
                        {link.label}
                      </a>
                    </li>
                  ) : (
                    <li key={link.label}>
                      <Link
                        to={link.href}
                        className="text-sm text-white/40 hover:text-white/70 transition-colors"
                        style={bodyFont}
                      >
                        {link.label}
                      </Link>
                    </li>
                  ),
                )}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-6 border-t border-white/[0.05] flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-xs text-white/30" style={bodyFont}>
            &copy; {new Date().getFullYear()} LUKHAS AI. All rights reserved.
          </p>
          <div className="flex gap-6">
            {['lukhas.ai', 'lukhas.com', 'lukhas.dev', 'lukhas.id'].map((domain) => (
              <a
                key={domain}
                href={`https://${domain}`}
                className="text-xs text-white/30 hover:text-white/50 transition-colors"
                style={bodyFont}
              >
                {domain}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  )
}
